import { useState, useCallback } from 'react';
import { saveAs } from 'file-saver';
import { API_ROOT } from '../constants';
import { HTTP_METHOD_GET } from '../constants/httpMethod';

export const useEbonDownload = (token) => {
    const [fetchingCodes, setFetchingCodes] = useState(false);
    const [fetchingBill, setFetchingBill] = useState(false);

    const downloadFile = useCallback(async (uri, filename) => {
        const config = {
            credentials: 'same-origin',
            method: HTTP_METHOD_GET,
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        try {
            const response = await fetch(`${API_ROOT}${uri}`, config);
            const blob = await response.blob();
            const file = new Blob([blob], { type: 'application/pdf' });
            saveAs(file, filename);
        } catch (error) {
            console.error('Error downloading file:', error);
            throw error;
        }
    }, [token]);

    const downloadCodes = useCallback(async (orderId) => {
        setFetchingCodes(true);
        try {
            await downloadFile(`/ebon/order/${orderId}/export`, `mes-ebons-${orderId}.pdf`);
        } finally {
            setFetchingCodes(false);
        }
    }, [downloadFile]);

    const downloadBill = useCallback(async (orderId) => {
        setFetchingBill(true);
        try {
            await downloadFile(`/ebon/order/${orderId}/bill`, `ma-facture-${orderId}.pdf`);
        } finally {
            setFetchingBill(false);
        }
    }, [downloadFile]);

    return {
        fetchingCodes,
        fetchingBill,
        downloadCodes,
        downloadBill
    };
};



// WEBPACK FOOTER //
// ./src/hooks/useEbonDownload.js